import { render, staticRenderFns } from "./TwinBed.vue?vue&type=template&id=88d40adc&"
import script from "./TwinBed.vue?vue&type=script&lang=js&"
export * from "./TwinBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports